module.exports = __webpack_public_path__ + "media/images/parceiros_pagamentos/mastercard-logo-c0925aeb9c84e87409165d2e8f375a8d.svg";